import React from 'react';
import { numberToPhone } from '../../utils';
import {
    formatAlertTs,
    formatDob,
    getPatientAge,
    isAlertOverdue,
    overdueLabel,
    dueRelativeLabel,
} from '../../utils/rpmAlertQueueUtils';
import RpmThresholdAlertListItem, { RpmSeverityBadge } from './RpmThresholdAlertListItem';

export { RpmSeverityBadge };

export const RpmThresholdPatientCell = ({ data }) => {
    const age = getPatientAge(data);
    return (
        <div>
            <div className="rpm-alert-patient__name">
                {`${data.first_name || ''} ${data.last_name || ''}`.trim()}
            </div>
            <div className="rpm-alert-muted">
                {`DOB: ${formatDob(data.date_of_birth)}`}{age != null ? ` · Age: ${age}` : ''}
            </div>
            <div className="rpm-alert-muted">{numberToPhone(data.phone)}</div>
            {(data.patient_id != null ? data.patient_id : data.id) != null &&
                <div className="rpm-alert-muted">
                    {`CCM ID: ${data.patient_id != null ? data.patient_id : data.id}`}
                </div>
            }
        </div>
    );
};

export const RpmThresholdDeviceCell = ({ data }) => (
    <div>
        {(data.rpm_device_type || data.rpm_device_type_id) &&
            <span className="rpm-device-pill">
                {data.rpm_device_type || `Device ${data.rpm_device_type_id}`}
            </span>
        }
    </div>
);

export const RpmThresholdProviderCell = ({ data }) => {
    const provider = data.provider || {};
    const locationLine = provider.location
        || provider.organization_secondary_name
        || provider.organization
        || '';
    return (
        <div>
            <div className="rpm-alert-provider__name">{provider.provider}</div>
            {locationLine && <div className="rpm-alert-muted">{locationLine}</div>}
            {provider.phone && <div className="rpm-alert-muted">{provider.phone}</div>}
        </div>
    );
};

const MAX_VISIBLE_RPM_ALERTS = 3;

export const RpmThresholdAlertCell = ({ data }) => {
    const alerts = data.rpm_sorted_alerts || data.alerts || [];
    const total = data.rpm_alert_total != null ? data.rpm_alert_total : alerts.length;
    const visibleAlerts = alerts.slice(0, MAX_VISIBLE_RPM_ALERTS);
    const hiddenCount = total > MAX_VISIBLE_RPM_ALERTS ? total - MAX_VISIBLE_RPM_ALERTS : 0;

    return (
        <div>
            <ul className="rpm-alert-column-list">
                {visibleAlerts.map((alert) =>
                    <RpmThresholdAlertListItem
                        key={alert.todo_id || alert.id}
                        alert={alert}
                    />
                )}
            </ul>
            {hiddenCount > 0 &&
                <div className="rpm-alert-more">{`+${hiddenCount}`}</div>
            }
        </div>
    );
};

export const RpmThresholdDueCell = ({ data }) => {
    const dueTs = data.rpm_earliest_due_ts;
    if (!dueTs) {
        return <span className="rpm-alert-muted">&mdash;</span>;
    }
    const overdue = isAlertOverdue(dueTs);
    return (
        <div className={overdue ? 'rpm-alert-due rpm-alert-due--overdue' : 'rpm-alert-due'}>
            <div className="rpm-alert-due__ts">{formatAlertTs(dueTs)}</div>
            {overdue
                ? <div>
                    <div className="rpm-alert-due__label">{overdueLabel(dueTs)}</div>
                    <span className="rpm-alert-pastdue-pill">
                        <i className="fa fa-clock-o" aria-hidden="true" /> PAST DUE
                    </span>
                </div>
                : dueRelativeLabel(dueTs) &&
                    <div className="rpm-alert-muted">{dueRelativeLabel(dueTs)}</div>
            }
        </div>
    );
};

export const RpmThresholdChartCell = ({ data, onOpenChart }) => {
    if (data.chart_open) {
        return (
            <span className="rpm-alert-open-by">
                {`Open by ${data.chart_open_by || 'another user'}`}
            </span>
        );
    }
    return (
        <div style={{ textAlign: 'center' }}>
            <button
                type="button"
                className="btn btn-primary rpm-alert-open-chart"
                onClick={() => onOpenChart(data)}
            >
                Open Chart
            </button>
            {data.assignee_name &&
                <div className="rpm-alert-muted">{data.assignee_name}</div>
            }
        </div>
    );
};
